import { createRouter, createWebHashHistory } from "vue-router";
import main from "@/views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "user",
				component: () => import("@/views/course/user.vue"),
			},
			{
				path: "/user",
				name: "user",
				component: () => import("@/views/course/user.vue"),
			},
			{
				path: "/post",
				name: "post",
				component: () => import("@/views/course/post.vue"),
			},
			{
				path: "/remark",
				name: "remark",
				component: () => import("@/views/course/remark.vue"),
			},
			{
				path: "/course",
				name: "course",
				component: () => import("@/views/course/course.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("@/views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
